import _ from 'lodash';

const modifyValue = (value) => {
  if (typeof value === 'number' || _.isNil(value)) {
    return value;
  }

  if (!_.isNaN(Date.parse(value))) {
    return new Date(value).getTime();
  }

  return value.toString();
};

export const orderOptions = (data, sortBy) => {
  return data.sort(function(a, b) {
    let result = 0;
    let i = 0;

    while (i < sortBy.length && result === 0) {
      const direction = sortBy[i].direction === 'ASC' ? 1 : -1;
      const nullPosition = sortBy[i].direction === 'ASC' ? 1 : -1;
      const field = sortBy[i].field;
      const firstValue = modifyValue(a[field]);
      const secondValue = modifyValue(b[field]);

      result = _.isNil(a[field])
        ? nullPosition
        : _.isNil(b[field])
        ? -nullPosition
        : direction * (firstValue < secondValue ? -1 : firstValue > secondValue ? 1 : 0);
      i++;
    }
    return result;
  });
};
